import { render, staticRenderFns } from "./RechargeStatistic.vue?vue&type=template&id=1b71bb58&"
import script from "./RechargeStatistic.vue?vue&type=script&lang=js&"
export * from "./RechargeStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports